import { HeaderImageStructure } from 'common/components';
import {
  BARNAUL,
  CHELYABINSK,
  CHEREPOVETS,
  KRASNOYARSK,
  NOVOSIBIRSK,
  ORENBURG,
  PERM,
  SAMARA,
  SURGUT,
  TOLYATTI,
  TYUMEN,
} from 'common/constants/region-codes';

export const FENCES_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/zabory-na-zakaz/';

export const FENCES_ELEMENT_BLOCK_MAP: Record<string, string> = {
  'main-page': 'landingZabory',
  'zabory-iz-profnastila': 'landingZaboryProfnastil',
  'metallicheskiy-shtaketnik': 'landingShtaketnik',
  'modulnye-ograzhdeniya': 'landingModulnyeOgrazhdeniya',
  'panelnye-ograzhdeniya': 'landingPanelnyeOgrazhdeniya',
  'zabory-zhalyuzi': 'landingZaboryZhalyuzi',
};

export const FENCES_TYPE_NAME_MAP: Record<string, string> = {
  'main-page': 'Заборы на заказ',
  'zabory-iz-profnastila': 'Заборы из профнастила на заказ',
  'metallicheskiy-shtaketnik': 'Металлический штакетник на заказ',
  'modulnye-ograzhdeniya': 'Модульные ограждения на заказ',
  'panelnye-ograzhdeniya': 'Панельные ограждения на заказ',
  'zabory-zhalyuzi': 'Заборы жалюзи на заказ',
};

export const FENCES_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/fences-mf';

export const FENCES_LANDING_NAME = 'fences';

export const FENCES_SERVICE_ID = '2112';

export const FENCES_CONSULTATION_TYPE = 'FENCE';

export const FENCES_REGION_LIST_WITHOUT_PANEL_MODUL_ZHALYUZI = [SAMARA, TOLYATTI, KRASNOYARSK, PERM];

export const FENCES_REGION_LIST_WITHOUT_PANEL_MODUL = [
  TYUMEN,
  SURGUT,
  CHELYABINSK,
  ORENBURG,
  NOVOSIBIRSK,
  BARNAUL,
  CHEREPOVETS,
];

type FencesHeaderStructure = {
  img: HeaderImageStructure;
  title: string;
  description: string;
  bgColor: string;
};

export const FENCES_HEADER_MAP: Record<string, FencesHeaderStructure> = {
  'main-page': {
    bgColor: '#725D5C',
    description:
      'Изготовим металлический забор для\u00A0участков любой площади под\u00A0ваши размеры и\u00A0потребности',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/main-page/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/main-page/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/main-page/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/main-page/header-m.jpg/header-m.jpg`,
      alt: 'Заборы на заказ',
    },
    title: 'Заборы на\u00A0заказ',
  },
  'zabory-iz-profnastila': {
    bgColor: '#53564F',
    description:
      'Профнастил\u00A0\u2014 это стальной лист с\u00A0цветным полимерным покрытием. Покрытие отвечает за\u00A0внешний вид, а\u00A0внутренний слой из\u00A0гальфана или цинка защищает от\u00A0воздействий окружающей среды. Доступны ограждения с\u00A0простым или декорированным краем',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/zabory-iz-profnastila/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/zabory-iz-profnastila/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/zabory-iz-profnastila/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/zabory-iz-profnastila/header-m.jpg/header-m.jpg`,
      alt: 'Заборы из профнастила на заказ',
    },
    title: 'Заборы из\u00A0профнастила на\u00A0заказ',
  },
  'metallicheskiy-shtaketnik': {
    bgColor: '#946961',
    description:
      'Металлический штакетник\u00A0\u2014 это ограждение из\u00A0металлических панелей с\u00A0разными вариантами профиля. Изготавливается из\u00A0оцинкованной стали с\u00A0полимерным покрытием, которое защищает металл от\u00A0внешних воздействий. На\u00A0выбор доступны разные покрытия и\u00A0цвета',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/metallicheskiy-shtaketnik/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/metallicheskiy-shtaketnik/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/metallicheskiy-shtaketnik/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/metallicheskiy-shtaketnik/header-m.jpg/header-m.jpg`,
      alt: 'Металлический штакетник на заказ',
    },
    title: 'Металлический штакетник на\u00A0заказ',
  },
  'modulnye-ograzhdeniya': {
    bgColor: '#4B4750',
    description:
      'Модульные ограждения\u00A0\u2014 это заборы из\u00A0профилированного листа и\u00A0набора профилей. Они изготовлены из\u00A0холоднокатаной горячеоцинкованной стали и\u00A0служат до\u00A050\u00A0лет. Доступны в\u00A0разной комплектации и\u00A0ценовой категории',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/modulnye-ograzhdeniya/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/modulnye-ograzhdeniya/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/modulnye-ograzhdeniya/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/modulnye-ograzhdeniya/header-m.jpg/header-m.jpg`,
      alt: 'Модульные ограждения на заказ',
    },
    title: 'Модульные ограждения на\u00A0заказ',
  },
  'panelnye-ograzhdeniya': {
    bgColor: '#A48A7E',
    description:
      'Панельные сетчатые ограждения состоят из\u00A0прутьев разной толщины с\u00A0рельефом или без. Элементы панельных ограждений изготовлены из\u00A0оцинкованной стали. Они устойчивы к\u00A0коррозии и\u00A0широко используются для ограждения общественных и\u00A0частных построек',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/panelnye-ograzhdeniya/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/panelnye-ograzhdeniya/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/panelnye-ograzhdeniya/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/panelnye-ograzhdeniya/header-m.jpg/header-m.jpg`,
      alt: 'Панельные ограждения на заказ',
    },
    title: 'Панельные ограждения на\u00A0заказ',
  },
  'zabory-zhalyuzi': {
    bgColor: '#607792',
    description:
      'Забор-жалюзи\u00A0\u2014 это секционное ограждение из\u00A0оцинкованной стали с\u00A0полимерным покрытием. Благодаря ламелям, расположенным под углом, забор пропускает воздух и\u00A0свет',
    img: {
      ldSrcSet: `${FENCES_CDN_PATH}/header/zabory-zhalyuzi/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${FENCES_CDN_PATH}/header/zabory-zhalyuzi/header-d.jpg/header-d.jpg`,
      tSrcSet: `${FENCES_CDN_PATH}/header/zabory-zhalyuzi/header-t.jpg/header-t.jpg`,
      mSrcSet: `${FENCES_CDN_PATH}/header/zabory-zhalyuzi/header-m.jpg/header-m.jpg`,
      alt: 'Заборы-жалюзи на заказ',
    },
    title: 'Заборы-жалюзи на\u00A0заказ',
  },
};

export const FENCES_STEP_LIST = [
  {
    title: 'Отправьте заявку',
    description:
      'Мы\u00A0перезвоним и\u00A0дадим бесплатную консультацию. Договоримся о\u00A0выезде специалиста для проведения замера.',
  },
  {
    title: 'Закажите замер',
    description:
      'Специалист приедет по\u00A0вашему адресу, составит обмерный план и\u00A0определит объём работ.',
  },
  {
    title: 'Мы\u00A0подготовим заказ',
    description:
      'Мы\u00A0подготовим расчёты и\u00A0проект по\u00A0изготовлению забора и\u00A0его монтажу. Составим смету и\u00A0оформим договор. Проект и\u00A0смета предоставляются бесплатно.',
  },
  {
    title: 'Примите материалы',
    description:
      'Мы\u00A0доставим готовый забор, или вы\u00A0можете забрать его самовывозом. Опытные специалисты установят забор на\u00A0вашем участке.',
  },
];
